import axios from "axios";

const axiosInstance = axios.create({ withCredentials: false });

axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("Manager-token");
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }

  return config;
});

export default axiosInstance;
